export const MapConfig = {
  styles: {
    linz: 'mapbox://styles/urbanintelligence/cljgef8p2002t01r7fr970avz?optimize=true',
    lightWithHouseNumbers:
      'mapbox://styles/urbanintelligence/cm3cgoyko002o01rg46ofhud7?optimize=true',
    contours: 'mapbox://styles/mapbox/outdoors-v12?optimize=true',
  },

  zoom: {
    region: 11,
    newZealand: 5.7,
  },

  locations: {
    newZealand: {
      center: [171.6418355, -41.1220914] as [number, number],
      zoom: 5.7,
    },
    christchurch: {
      center: [172.6362, -43.5321] as [number, number],
      zoom: 12,
    },
    auckland: {
      center: [174.7633, -36.8485] as [number, number],
      zoom: 12,
    },
  },

  defaults: {
    style: 'lightWithHouseNumbers',
    location: 'newZealand',
  },
} as const
